import { useState } from "react";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import { useNavigate } from "react-router";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import { ADMIN_CMS_FAQ } from "../../../../action/apiPath";
import { errorMessageCreate } from "../../../../util/custom";
import { ADMINCMSFAQSPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

const AdminFaqAdd = () => {
    const navigate = useNavigate()
    const [faq, setFaq] = useState({
        question: "",
        answer: ""
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFaq({ ...faq, [name]: value });
    };

    const handleSubmit = async () => {
        if (!faq.question) {
            showToast("error", "Question is required.");
            return;
        }

        if (!faq.answer) {
            showToast("error", "Answer is required.");
            return;
        }

        try {
            setIsSubmit(true);

            let response = await CallWithAuth("POST", ADMIN_CMS_FAQ, faq);

            let message = errorMessageCreate(response?.res?.data?.message);
            if (response?.res?.data?.statusCode === 201) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(`${ADMINCMSFAQSPAGE}`);
                    setIsSubmit(false);
                }, 1000);

            } else {
                let message = errorMessageCreate(response?.res?.data?.message);
                showToast("error", message);
                setIsSubmit(false);
            }
        } catch (err) {
            console.log(err);
            setIsSubmit(false);
        }
    };

    return (
        <div>
            {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

            <section class="site_hero patient_management_banner">
                <div class="site_container">
                    <div class="site_row">
                        <div class="txt_colm">
                            <div class="txt_block">
                                <h1>Manage Faq</h1>
                                <p>Manage each Faq efficiently</p>
                            </div>
                        </div>
                        <div class="img_colm">
                            <div class="img_block">
                                <img src={patient} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mycustomclass patient_form_block">
                <div class="site_container">
                    <div class="patient_form">
                        <div className="field_block">
                            <label htmlFor="question">Question*</label>
                            <input
                                type="text"
                                name="question"
                                className="text_field"
                                placeholder="Enter Question"
                                value={faq.question}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="field_block">
                            <label htmlFor="answer">Answer*</label>
                            <input
                                type="text"
                                name="answer"
                                className="text_field"
                                placeholder="Enter Answer"
                                value={faq.answer}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="field_block">
                            <div className="btn_row">
                                <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                    <span>Submit </span> <img src={rightArrow} alt="Arrow" />
                                    {isSubmit && (
                                        <>
                                            {""}
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
            <ToastContainer />

        </div>
    );
};

export default AdminFaqAdd;
